import { useTranslation } from 'react-i18next';
import React  from 'redux';
import { useState } from 'react';
import { To, useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';

import './Header.scss';
import { APP_BASE_PATH } from '../../Constants';
import { ChangeLanguageDialog } from '../dialogs/ChangeLanguage';
import { ChangeLanguageButton } from '../dialogs/ChangeLanguage/ChangeLanguageButton';
import { Play60s } from '../LuckyMinute/LuckyMinute';
import { PayoutInfo } from '../dialogs/PayoutInfo';
import { GameType } from '../../Utils';
import { UserActions } from '../../Store/Actions';

interface props {
  logo?: boolean;
  backToHome?: boolean;
  backToUrl?: string;
  leftMenu?: boolean;
  name?: string;
  agentMenu?: boolean;
  menu?: boolean;
  login?: boolean;
  background?: string;
  showLang?: boolean;
  gameType?: GameType;
}

const map = {
  [GameType.Baccarat]: '/img/baccarat_text_both.svg',
  [GameType.SicBo]: '/img/sicbo_text_both.svg',
  [GameType.Roulette]: '/img/roulette_text_both.svg',
};

const Header = (props: props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [languageSelector, setLanguageSelector] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const redirect = (url) => {
    navigate(url);
  };

  const logout = () => {
    UserActions.logout();
  };

  return (
    <div className={'header bg_'+props.background}>

      {props.login && (<button className='header_btn outlined green' onClick={() => redirect('Trial')}>{t('trial.play')}</button>)}
      {!props.login && props.leftMenu && (
        <div className="left_menu">
          <Dropdown className='main_menu'>
            <Dropdown.Toggle id='dropdown_basic'>
              <i className='fa-solid fa-bars game_info'></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => redirect(APP_BASE_PATH)}>
                {t('label.login')}</Dropdown.Item>
              <Dropdown.Item onClick={() => setLanguageSelector(true)}>
                {t('menu.language')} <span>{i18n.language == 'en' ? '中文' : 'ENG'}</span></Dropdown.Item>
              <Dropdown.Item onClick={() => redirect('/')}>
                {t('menu.statistics')}</Dropdown.Item>
              <Dropdown.Item onClick={() => redirect('/')}>
                {t('menu.pastResults')}</Dropdown.Item>
              <Dropdown.Item onClick={() => redirect('/')}>
                {t('menu.gameGuides')}</Dropdown.Item>
              <Dropdown.Item onClick={() => redirect('/')}>
                {t('menu.platform')}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      {!props.login && !props.leftMenu && props.logo && (
        <div className='header_button'>
          <img className='back_btn' src='/logo192.png' alt='Logo' />
        </div>
      )}
      {!props.login && !props.leftMenu && !props.logo && (
        <div className='header_button' onClick={() => navigate((props.backToHome ? APP_BASE_PATH : (props.backToUrl || -1) as To))}>
          <i className='fa-solid fa-angle-left back_btn'></i>
        </div>
      )}
      {props.name === 'Play60s' && (<Play60s />)}
      {props.name !== 'Play60s' && !props.gameType &&  (
        <span className='user_name'>{props.name}</span>
      )}
      {props.name !== 'Play60s' && props.gameType &&  (
        <img className='game_logo' src={map[props.gameType]} alt='Game Logo' />
      )}
      {props.login && (<ChangeLanguageButton narrow={true} />)}
      {props.showLang && (<ChangeLanguageButton narrow={true} />)}

      {props.agentMenu && (
        <Dropdown className='main_menu'>
          <Dropdown.Toggle id='dropdown_basic'>
            <i className='fa-solid fa-ellipsis-vertical game_info'></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setLanguageSelector(true)}>
              {t('menu.language')} <span>{i18n.language == 'en' ? '中文' : 'ENG'}</span></Dropdown.Item>
            <Dropdown.Item onClick={() => logout()}>
              {t('label.logout')}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
      {props.menu && (
        <Dropdown className='main_menu'>
          <Dropdown.Toggle id='dropdown_basic'>
            <i className='fa-solid fa-ellipsis-vertical game_info'></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => redirect(`${APP_BASE_PATH}/TransactionRecord`)}>
              {t('menu.transactions')}</Dropdown.Item>
            <Dropdown.Item onClick={() => redirect(`${APP_BASE_PATH}/BetHistory`)}>
              {t('menu.betHistory')}</Dropdown.Item>
            <Dropdown.Item onClick={() => setLanguageSelector(true)}>
              {t('menu.language')} <span>{i18n.language == 'en' ? '中文' : 'ENG'}</span></Dropdown.Item>
            {/*<Dropdown.Item onClick={() => redirect(`${APP_BASE_PATH}/SoundVibrate`)}>*/}
            {/*  {t('menu.sound')}</Dropdown.Item>*/}
          </Dropdown.Menu>
        </Dropdown>
      )}
      { props.gameType && !props.menu && !props.agentMenu && !props.login && (
        <div className='header_button' onClick={() => setShowInfo(true)}>
          <img className='back_btn' src='/img/payout_icon.png' alt='btn' />
        </div>
      )}
      { showInfo && (
        <PayoutInfo gameType={props.gameType} close={() => setShowInfo(false)} />
      )}

      {languageSelector && (
        <ChangeLanguageDialog callback={() => {setLanguageSelector(false);}} />
      )}
    </div>
  );
};
export default Header;
